import {IconButton, Tooltip} from '@mui/material';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/pro-duotone-svg-icons";
import Link from "next/link";

const SignInButton = ({url}: {
    url: string;
}) => {
    return (
        <Tooltip title="Sign In" arrow>
            <IconButton size="large">
                <Link href={url ?? '#'}>
                    <FontAwesomeIcon color={'#1ea455'} icon={faUserCircle} style={{fontSize: '1.75rem'}}/>
                </Link>
            </IconButton>
        </Tooltip>
    )
};

export default SignInButton;
